import { EditClient } from './EditClient.main';

export { EditClient };
